<ng-container
  *ngIf="{
    responseId: responseId$ | async
  } as data"
>
  <cng-contact-view-layout>
    <ng-template cngContactViewLayoutActions>
      <chat-actions [responseId]="data.responseId"></chat-actions>
    </ng-template>
    <ng-template cngContactViewLayoutWorkspace>
      <chat-workspace [responseId]="data.responseId"></chat-workspace>
    </ng-template>
  </cng-contact-view-layout>
</ng-container>
